import { Component, OnInit } from '@angular/core';
import {
    ShippingDetails,
    ShippingFulfillmentStrategy,
    TalonOneWebCode
} from 'src/app/shared-core/models/cart-data.model';
import { CartOrder, CheckoutData } from 'src/app/shared-core/models/checkout-data.model';
import { CartParserService } from '../../shared-core/services/cart-parser.service';
import { CheckoutService } from 'src/app/shared-core/services/checkout.service';
import { KlaviyoService } from 'src/app/shared-core/services/klaviyo.service';

@Component({
  selector: 'checkout-cart-items',
  templateUrl: './cart-items.component.html',
  styleUrls: ['./cart-items.component.scss'],
})
export class CartItemsComponent implements OnInit {
  TalonOneWebCode = TalonOneWebCode;
  model: CheckoutData = new CheckoutData();
  cartOrder: CartOrder;
  isWaiting: boolean = false;
  shippingDetails: ShippingDetails;
  
  public get dropshippedItems(): string[] {
      const fulfillmentStrategy = this.shippingDetails?.ShippingQuote?.FulfillmentStrategy;

      return fulfillmentStrategy?.DropshipQuoteRequiredItems ?? [];
  }
  
  public get hasShippableItems(): boolean {
      const fulfillmentStrategy = this.shippingDetails?.ShippingQuote?.FulfillmentStrategy;

      return fulfillmentStrategy?.ImmediateShippingAvailableItems?.length > 0 
          || fulfillmentStrategy?.UnableToImmediatelyShipItems?.length > 0;
  }

  public get showDropshippingBadge(): boolean {
    return this.dropshippedItems.length > 0 && this.hasShippableItems;
  }
  
  constructor(
    private service: CheckoutService,
    private _klaviyoService: KlaviyoService
  ) { }

  ngOnInit(): void {
    this.service.CheckoutDataSubject.subscribe((checkoutData) => {
      if (!checkoutData) {
        return;
      }

      this.model = checkoutData;
      this.cartOrder = checkoutData.CartOrder;
      this.shippingDetails = checkoutData.ShippingDetails;
      
      this._klaviyoService.startedCheckout(checkoutData);
    });
  }

  public getImageURL(imgURI: string) {
    if (!imgURI) return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
    return 'https://img.vistek.net' + imgURI[0];
  }
  public getPlanImageURL(imgURI: string) {
    if (!imgURI) return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
    let imageName = imgURI.substring(3, imgURI.length - 2);
    return 'https://img.vistek.net/' + imageName;
  }

  removeItem() {
    this.service.updatePromoCode('').subscribe();
  }
}
